import { useSyncExternalStore } from 'react';
import { ArtSplash } from './ArtSplash.js';
import './StartupScreen.css';

/** Presentation only: readiness and session access remain owned by the caller. */
export function StartupScreen({
  title,
  description = 'Just a moment…',
  titleId,
  descriptionId,
  embedded = false,
}: {
  title: string;
  description?: string;
  titleId?: string;
  descriptionId?: string;
  embedded?: boolean;
}) {
  const mobile = useSyncExternalStore(subscribeMobile, isMobile, () => false);
  const status = (
    <span id={descriptionId} className="sr-only" role="status">
      {description}
    </span>
  );
  if (!mobile)
    return (
      <div
        className="admin-startup"
        aria-busy="true"
        data-mode="desktop"
        data-embedded={embedded || undefined}
      >
        <div className="admin-startup__plain">
          <span className="admin-startup__spinner" aria-hidden="true" />
          <h1 id={titleId}>{title}</h1>
          {status}
        </div>
      </div>
    );
  return (
    <div
      className="admin-startup"
      aria-busy="true"
      data-mode="mobile"
      data-embedded={embedded || undefined}
    >
      <ArtSplash
        headingAs="h1"
        headingId={titleId}
        accessibleHeading={title}
        markClassName="admin-startup__mark"
      >
        {status}
      </ArtSplash>
    </div>
  );
}

function isMobile() {
  return (
    typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 1023px)').matches
  );
}
function subscribeMobile(onChange: () => void) {
  if (typeof window.matchMedia !== 'function') return () => {};
  const media = window.matchMedia('(max-width: 1023px)');
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
}
